{
  "title": "Sviluppatore",
  "UI": {
    "title": "Interfaccia utente"
  },
  "createDeviceActionSchedule": {
    "title": "Crea pianificazione azione dispositivo"
  },
  "schedulesView": {
    "title": "Orari"
  },
  "alertsDemo": {
    "alerts": "Avvisi",
    "linkTo": "Avvisi Demo",
    "showTitleCheckbox": "Titolo",
    "title": "Avvisi Demo"
  },
  "buttonsDemo": {
    "actionButtons": "Pulsanti di azione {{direction}}",
    "title": "Demo dei pulsanti"
  },
  "devLanding": {
    "linkTo": "atterraggio dello sviluppatore",
    "title": "Atterraggio dello sviluppatore"
  },
  "fontDemo": {
    "italic": "Corsivo",
    "linkTo": "demo del font",
    "regular": "Regolare",
    "subheader": "Titolo secondario",
    "title": "Dimostrazione del carattere"
  },
  "linkTo": "Sviluppatore",
  "scratch": {
    "linkTo": "graffio",
    "title": "Graffio"
  }
}
